/*
  Adds .daoud-sold-out-visual to add-to-cart buttons once their disabled state has genuinely
  persisted, not the moment it's set. product-form.js disables the button as a generic loading
  guard on every variant switch (~300-400ms), whether or not the new variant is actually sold
  out — styling straight off :disabled flashes the sold-out treatment on available variants
  too. A real sold-out button stays disabled indefinitely (server-rendered, nothing reverts
  it), so debouncing past the loading window tells the two cases apart.
*/
(function () {
  var DELAY = 450;
  var timers = new WeakMap();

  function isDisabled(button) {
    return button.disabled || button.getAttribute('aria-disabled') === 'true';
  }

  function apply(button) {
    var pending = timers.get(button);
    if (isDisabled(button)) {
      if (!pending) {
        pending = window.setTimeout(function () {
          button.classList.add('daoud-sold-out-visual');
        }, DELAY);
        timers.set(button, pending);
      }
    } else {
      if (pending) window.clearTimeout(pending);
      timers.set(button, null);
      button.classList.remove('daoud-sold-out-visual');
    }
  }

  function watch(button) {
    if (timers.has(button)) return;
    timers.set(button, null);

    if (isDisabled(button)) {
      // Already disabled at first sight (server-rendered sold out) — no debounce, show it now.
      button.classList.add('daoud-sold-out-visual');
    }

    new MutationObserver(function () {
      apply(button);
    }).observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }

  function scan(root) {
    if (root.matches && root.matches('button[name="add"]')) watch(root);
    root.querySelectorAll && root.querySelectorAll('button[name="add"]').forEach(watch);
  }

  scan(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
